import { InternRelativeInformation } from '../intern/relative-information';
import { InternTrackingInformation } from '../intern/tracking-information';

/**
 * Model definition for Action Link
 */
export interface LinkActionLink {
  __component: 'link.action-link';
  id: string;
  text: string;
  title?: string;
  action?: 'directoryUp' | 'toTop' | 'toggleNavigation' | 'showPrivacyCenter' | 'openServiceBox';
  rel?: InternRelativeInformation;
  tracking?: InternTrackingInformation;
}

export function isLinkActionLink(obj: { __component?: string }): obj is LinkActionLink {
  return obj.__component === 'link.action-link';
}
